import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { TextField, FormControl, MenuItem, Select, Button, Alert, Snackbar  } from '@mui/material'
import axios from 'axios';


const BasicConfig = () => {

  return (
    <div>
      <Homepage />
      {/* <Freeboard /> */}
      <SignUp />
      <Insta />
    </div>
  )
}


const useStylesHomepage = makeStyles((theme)=>({ 
  row:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  basicConfigBlock:{
    fontSize:'14px'
  },
  basicConfigBlockH1:{
    padding:'40px 0 0 10px',
    fontWeight:'700',
    fontSize:'22px',

  },
  basicConfigLi:{ 
    display:'flex',    
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  basicConfigSpan:{
    width:'250px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      paddingBottom:'10px'
    },
  },
  UlLi:{
    paddingBottom:'10px'
  },
  UlLiP:{
    display:'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start'
  },
  basicConfigLeftDiv:{
    width:'250px',
    textAlign:'left',
  },
  textFieldShort:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  textFieldLong:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'100%',
    },
  },
  formControl:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  formControlSelect:{ 
    width:'100%',
  },
  twoFlexLi:{
    display:'flex',
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  basicConfigLiLeft:{
    width:'50%',
    display:'flex',  
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
      paddingBottom:'10px'
    },
  },
  basicConfigLiRight:{
    width:'50%',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
    },
  },
  checkboxLi:{
    position:'relative',
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px',
  },
  btnButton:{
    margin:'0 40px',
  },
  basicConfigLiTextarea:{
    width:'440px',
    height:'100px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  }

}));
const Homepage = () => {

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const theme = useTheme();
  const classes = useStylesHomepage(theme);

  //기본환경1
  const [cfTitle, setCfTitle] = useState('');
  const [cfAdmin, setCfAdmin] = useState('');
  const [cfAdminEmail, setcfAdminEmail] = useState('');
  const [cfAdminEmailName, setcfAdminEmailName] = useState('');
  const [cfUsePoint, setcfUsePoint] = useState('');
  const [cfCutName, setcfCutName] = useState('');
  const [cfPossibleIp, setcfPossibleIp] = useState('');
  const [cfInterceptIp, setcfInterceptIp] = useState('');

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);


  const getData = async() => {
    try {
      const res = await axios.get('/api/adm/configPart1/') 

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      const resData = res.data.result

      setCfTitle(resData.cf_title)
      setCfAdmin(resData.cf_admin)
      setcfAdminEmail(resData.cf_admin_email)
      setcfAdminEmailName(resData.cf_admin_email_name)
      setcfUsePoint(resData.cf_admin)
      setcfCutName(resData.cf_cut_name)
      setcfPossibleIp(resData.cf_possible_ip)
      setcfInterceptIp(resData.cf_intercept_ip)    
    }catch (e) {
    
      console.log(e)
    }
  }
  useEffect(() => {
    getData()
  }, [])

  const editData = async() => {
    try {
      const res = await axios.post('/api/adm/configEdit1/', {
        cf_title: cfTitle,
        cf_admin: cfAdmin,
        cf_admin_email: cfAdminEmail,
        cf_admin_email_name: cfAdminEmailName,
        cf_use_point: cfUsePoint,
        cf_cut_name: cfCutName,
        cf_possible_ip: cfPossibleIp,
        cf_intercept_ip: cfInterceptIp,
      })

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      setSuccSnack(true)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }

  }

  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return (
    <div className={classes.basicConfigBlock}>      
      <div className={classes.row}>
        <h1 className={classes.basicConfigBlockH1}>기본환경설정</h1>
        <ul className={classes.basicConfigUl}>
          <li className={classes.basicConfigLi}>
            <span className={classes.basicConfigSpan}>홈페이지 제목</span>
            <TextField 
              value={cfTitle} 
              onChange={(event) => setCfTitle(event.target.value)}  
              size='small' 
              sx={{"& .MuiInputBase-root": {height: 25}}} 
              className={classes.textFieldShort} 
              hiddenlabel="true" 
              variant="outlined" 
            />
          </li>
          <li className={classes.basicConfigLi}>
            <span className={classes.basicConfigSpan} >최고관리자</span>
            <FormControl className={classes.formControl} sx={{"& .MuiInputBase-root": {height: 25}}}>
              <Select 
                value={cfAdmin}
                hiddenlabel="true"
                onChange={(event) => setCfAdmin(event.target.value)}
                className={classes.formControlSelect}
                size='small'
                sx={{"& .MuiInputBase-root": {height: 25}}}
              >
                <MenuItem value={''}>선택안함</MenuItem>
                <MenuItem value={'admin'}>admin</MenuItem>
              </Select>
            </FormControl>
          </li>
          <li className={classes.basicConfigLi}>
            <div className={classes.basicConfigLeftDiv}>
              <span className={classes.basicConfigSpan} >관리자 메일 주소</span>
            </div>
            <ul>
              <li className={classes.UlLi}>
                <span>관리자가 보내고 받는 용도로 사용하는 메일 주소를 입력합니다.</span>
              </li>
              <li>              
                <TextField 
                  name='cfAdminEmail' 
                  value={cfAdminEmail} 
                  onChange={(event) => setcfAdminEmail(event.target.value)} 
                  size='small' 
                  sx={{"& .MuiInputBase-root": {height: 25}}} 
                  className={classes.textFieldLong} 
                  hiddenlabel="true" 
                  variant="outlined" 
                />
              </li>
            </ul>
          </li>
          <li className={classes.basicConfigLi}>
            <div className={classes.basicConfigLeftDiv}>
              <span className={classes.basicConfigSpan} >관리자 메일 발송이름</span>
            </div>
            <ul>
              <li className={classes.UlLi}><span>관리자가 보내고 받는 용도로 사용하는 메일의 발송이름을 입력합니다.</span></li>
              <li>
                <TextField 
                  name='cfAdminEmailName' 
                  value={cfAdminEmailName} 
                  onChange={(event) => setcfAdminEmailName(event.target.value)} 
                  size='small' sx={{"& .MuiInputBase-root": {height: 25}}} 
                  className={classes.textFieldLong}  
                  hiddenlabel="true" 
                  variant="outlined" 
                />
              </li>
            </ul>
          </li>
          {/* <li className={classes.basicConfigLi}>
            <span className={classes.basicConfigSpan} >포인트 사용</span>
            <span>
              <Checkbox 
                value={cfUsePoint === 0 ? false : true} 
                onChange={(event) => {
                  cfUsePoint === 0 ?
                  setcfUsePoint(1):
                  setcfUsePoint(0)
                }} 
                {...label} 
              />
              사용
            </span>
          </li>
          
          <li className={classes.basicConfigLi}>
            <span className={classes.basicConfigSpan} >이름(닉네임) 표시</span>
            <TextField 
              name='cfCutName' 
              value={cfCutName} 
              onChange={(event) => setcfCutName(event.target.value)} 
              size='small' sx={{"& .MuiInputBase-root": {height: 25}}} 
              className={classes.textFieldShort} 
              hiddenlabel="true" 
              variant="outlined"
            />
          </li> */}
          {/* <li className={classes.twoFlexLi}>
            <div className={classes.basicConfigLiLeft}>
              <span className={classes.basicConfigSpan} >접근가능 IP</span>
              <ul>
                <li>
                  <span>입력된 IP의 컴퓨터만 접근할 수 있습니다.</span>
                </li>
                <li>
                  <span>123.123.+ 도 입력 가능. (엔터로 구분)</span>
                </li>
                <li>
                  <textarea name='cfPossibleIp' value={cfPossibleIp} onChange={(event) => setcfPossibleIp(event.target.value)} className={classes.basicConfigLiTextarea} />
                </li>
              </ul>
            </div>
            <div className={classes.basicConfigLiRight}>
              <span className={classes.basicConfigSpan} >접근차단 IP</span>
              <ul>
                <li>
                  <span>입력된 IP의 컴퓨터는 접근할 수 없음.</span>
                </li>
                <li>
                  <span>123.123.+ 도 입력 가능. (엔터로 구분)</span>
                </li>
                <li>
                  <textarea 
                    name='cfInterceptIp' 
                    value={cfInterceptIp} 
                    onChange={(event) => setcfInterceptIp(event.target.value)} 
                    className={classes.basicConfigLiTextarea} 
                  />
                </li>
              </ul>
            </div>
          </li> */}
        </ul>
        <div className={classes.btnDiv}>
          <div>
            <Button 
              variant="contained"
              onClick={() => {editData()}} 
            >
              확인
            </Button>
          </div>
        </div>
      </div>   

      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
    </div>       
  )
}


const useStylesFreeboard = makeStyles((theme)=>({ 
  row:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  basicConfigBlock:{
    fontSize:'14px'
  },
  firstSpanDiv:{
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2'
  },
  basicConfigBlockH1:{
    padding:'40px 0 0 10px',
    fontWeight:'700',
    fontSize:'22px',

  },
  basicConfigLi:{ 
    display:'flex',    
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  basicConfigSpan:{
    width:'250px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      paddingBottom:'10px'
    },
  },
  oneSpan:{
    display:'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
  },
  UlLi:{
    paddingBottom:'10px'
  },
  basicConfigLeftDiv:{
    width:'250px',
    textAlign:'left',
  },
  textFieldLong:{
    width:'440px',
    
    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px'
  },
  btnButton:{
    margin:'0 40px'
  },
  basicConfigLiTextarea:{
    width:'440px',
    height:'100px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },

}));
const Freeboard = () => {

  const theme = useTheme();
  const classes = useStylesFreeboard(theme);

  //기본환경설정2
  const [cfImageExtension, setcfImageExtension] = useState('');
  const [cfFilter, setcfFilter] = useState('');

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const getData = async() => {
    try{
      const res = await axios.get('/api/adm/configPart2/')

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      const resData = res.data.result

      setcfImageExtension(resData.cf_image_extension)
      setcfFilter(resData.cf_filter)
    }catch(e) {
      console.log(e)
    }
  }
  useEffect(() => {
    getData()
  }, [])
  
  const editData = async() => {
    try {
      const res = await axios.post('/api/adm/configEdit2/', {
        cf_image_extension: cfImageExtension,
        cf_filter: cfFilter,
      })

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      setSuccSnack(true)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }


  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return(
    <div className={classes.basicConfigBlock}>
      <div className={classes.row}>
        <h1 className={classes.basicConfigBlockH1}>게시판 기본 설정</h1>
        <div className={classes.firstSpanDiv}>
          <span className={classes.firstSpan}>각 게시판 관리에서 개별적으로 설정 가능합니다.</span>
        </div>
        <ul className={classes.basicConfigUl}>
          <li className={classes.basicConfigLi}>
            <div className={classes.basicConfigLeftDiv}>
              <span className={classes.basicConfigSpan}>이미지 업로드 확장자</span>
            </div>
            <ul>
              <li className={classes.UlLi}><span>게시판 글작성시 이미지 파일 업로드 가능 확장자. | 로 구분</span></li>
              <li>              
                <TextField 
                  value={cfImageExtension} 
                  onChange={(event) => setcfImageExtension(event.target.value)} 
                  size='small' 
                  sx={{"& .MuiInputBase-root": {height: 25}}} 
                  className={classes.textFieldLong} 
                  hiddenlabel="true" 
                  variant="outlined" 
                />
              </li>
            </ul>
          </li>
          <li className={classes.basicConfigLi}>
            <span className={classes.basicConfigSpan}>단어 필터링</span>
            <ul>
              <li>
                <span>입력된 단어가 포함된 내용은 게시할 수 없습니다. 단어와 단어 사이는 ,로 구분합니다.</span>
              </li>
              <li>
                <textarea 
                  value={cfFilter} 
                  onChange={(event) => setcfFilter(event.target.value)} 
                  className={classes.basicConfigLiTextarea}
                />
              </li>
            </ul>            
          </li>
          <div className={classes.btnDiv}>
            <div>
            <Button 
              variant="contained"
              onClick={() => {editData()}} 
            >
              확인
            </Button>
            </div>
          </div>
        </ul>
      </div>

      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
    </div>
  )
}


const useStylesSignUp = makeStyles((theme)=>({ 
  row:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  basicConfigBlock:{
    fontSize:'14px'
  },
  basicConfigBlockH1:{
    padding:'40px 0 0 10px',
    fontWeight:'700',
    fontSize:'22px',

  },
  basicConfigLi:{ 
    display:'flex',    
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  basicConfigSpan:{
    width:'250px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      paddingBottom:'10px',
    },
  },
  oneSpanDiv:{
    display:'flex'
  },
  oneSpan:{
    display:'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start'
  },
  oneSpanTextFieldShort:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'50%'
    },
  },
  textFieldShort:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  UlLi:{
    paddingBottom:'10px'
  },
  UlLiP:{
    display:'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
  },
  basicConfigLeftDiv:{
    width:'250px',
    textAlign:'left',
  },
  formControl:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  formControlSelect:{ 
    width:'100%',
  },
  twoFlexLi:{
    display:'flex',
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  basicConfigLiLeft:{
    width:'50%',
    display:'flex', 
    alignItems:'center', 

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
      paddingBottom:'10px'
    },
  },
  basicConfigLiRight:{
    width:'50%',
    display:'flex', 
    alignItems:'center', 

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
    },
  },
  checkboxLi:{
    position:'relative'
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px'
  },
  btnButton:{
    margin:'0 40px'
  },
  basicConfigLiTextarea:{
    width:'440px',
    height:'100px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  }

}));
const SignUp = () => {

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const theme = useTheme();
  const classes = useStylesSignUp(theme);

  //기본환경설정3
  const [cfRegisterLevel, setcfRegisterLevel] = useState(0);
  const [cfRegisterPoint, setcfRegisterPoint] = useState(0);
  const [cfLeaveDay, setcfLeaveDay] = useState(0);
  const [cfProhibitId, setcfProhibitId] = useState('');
  const [cfProhibitEmail, setcfProhibitEmail] = useState('');
  const [cfStipulation, setcfStipulation] = useState('');
  const [cfPrivacy, setcfPrivacy] = useState('');

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const getData = async() => {
    try{
      const res = await axios.get('/api/adm/configPart3/')
      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      const resData = res.data.result

      setcfRegisterLevel(resData.cf_register_level)
      setcfRegisterPoint(resData.cf_register_point)
      setcfLeaveDay(resData.cf_leave_day)
      setcfProhibitId(resData.cf_prohibit_id)
      setcfProhibitEmail(resData.cf_prohibit_email)
      setcfStipulation(resData.cf_stipulation)
      setcfPrivacy(resData.cf_privacy)
    }catch(e){
      console.log(e)
    }
  }
  useEffect(() => {
    getData()
  }, [])

  const editData = async() => {
    try {
      const res = await axios.post('/api/adm/configEdit3/', {
        cf_register_level: cfRegisterLevel,
        cf_register_point: cfRegisterPoint,
        cf_leave_day: cfLeaveDay,
        cf_prohibit_id: cfProhibitId,
        cf_prohibit_email: cfProhibitEmail,
        cf_stipulation: cfStipulation,
        cf_privacy: cfPrivacy,
      })

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      setSuccSnack(true)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }


  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };


  return(
    <div className={classes.basicConfigBlock}>
      <div className={classes.row}>
        <h1 className={classes.basicConfigBlockH1}>회원가입 설정</h1>
        <ul className={classes.basicConfigUl}>
          <li className={classes.twoFlexLi}>
            <div className={classes.basicConfigLiLeft}>
            <span className={classes.basicConfigSpan}>회원가입시 권한</span>
              <ul>
                <li>
                  <FormControl sx={{"& .MuiInputBase-root": {height: 25}}} className={classes.formControl}>
                    <Select 
                      value={cfRegisterLevel}
                      hiddenlabel="true"
                      onChange={(event) => setcfRegisterLevel(event.target.value)}
                      className={classes.formControlSelect}
                      size='small'
                    >
                      <MenuItem value={0}>0</MenuItem>
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={4}>4</MenuItem>
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={6}>6</MenuItem>
                      <MenuItem value={7}>7</MenuItem>
                      <MenuItem value={8}>8</MenuItem>
                      <MenuItem value={9}>9</MenuItem>
                    </Select>
                  </FormControl>
                </li>
              </ul>
            </div>
            <div className={classes.basicConfigLiRight}>
              <span className={classes.basicConfigSpan}>회원가입시 포인트</span>
              <ul>                   
                <li>
                  <span className={classes.UlLiP}>
                    <TextField 
                      value={cfRegisterPoint} 
                      onChange={(event) => setcfRegisterPoint(parseInt(event.target.value))} 
                      size='small' 
                      sx={{"& .MuiInputBase-root": {height: 25}}} 
                      className={classes.textFieldShort} 
                      hiddenlabel="true" 
                      variant="outlined" 
                      type='number'
                    />
                    <span className={classes.UlLiPSpan}>점</span>
                  </span>
                </li>
              </ul>
            </div>
          </li>
          {/* <li className={classes.basicConfigLi}>
            <span className={classes.basicConfigSpan}>회원탈퇴후 삭제일</span>
            <div className={classes.oneSpanDiv}>
              <TextField 
                value={cfLeaveDay} 
                onChange={(event) => setcfLeaveDay(parseInt(event.target.value))} 
                size='small' sx={{"& .MuiInputBase-root": {height: 25}}} 
                className={classes.oneSpanTextFieldShort} 
                hiddenlabel="true" 
                variant="outlined"
                type='number'
              />
              <span className={classes.oneSpan}>일 후 자동 삭제</span>
            </div>
          </li> */}
          
          <li className={classes.twoFlexLi}>
            <div className={classes.basicConfigLiLeft}>
              <span className={classes.basicConfigSpan}>아이디,닉네임 금지단어</span>
              <ul>
                <li>
                  <span>회원아이디, 닉네임으로 사용할 수 없는 단어를 정합니다. 쉼표 (,) 로 구분</span>
                </li>
                <li>
                  <textarea 
                    value={cfProhibitId} 
                    onChange={(event) => setcfProhibitId(event.target.value)} 
                    className={classes.basicConfigLiTextarea} 
                  />
                </li>
              </ul>
            </div>
            {/* <div className={classes.basicConfigLiRight}>
              <span className={classes.basicConfigSpan}>입력 금지 메일</span>
              <ul>
                <li>
                  <span>입력 받지 않을 도메인을 지정합니다. 엔터로 구분 ex) hotmail.com</span>
                </li>
                <li>
                  <textarea 
                    value={cfProhibitEmail} 
                    onChange={(event) => setcfProhibitEmail(event.target.value)} 
                    className={classes.basicConfigLiTextarea} 
                  />
                </li>
              </ul>
            </div> */}
          </li>
          <li className={classes.basicConfigLi}>
            <span className={classes.basicConfigSpan}>회원가입약관</span>
            <textarea 
              value={cfStipulation} 
              onChange={(event) => setcfStipulation(event.target.value)} 
              className={classes.basicConfigLiTextarea}
            />        
          </li>
          <li className={classes.basicConfigLi}>
            <span className={classes.basicConfigSpan}>개인정보처리방침</span>
            <textarea 
              value={cfPrivacy} 
              onChange={(event) => setcfPrivacy(event.target.value)} 
              className={classes.basicConfigLiTextarea}
            />        
          </li>
        </ul>
        <div className={classes.btnDiv}>
          <div>
            <Button 
              variant="contained"
              onClick={() => {editData()}} 
            >
              확인
            </Button>
          </div>
        </div>
      </div>

      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
    </div>
  )
}


const useStylesInsta = makeStyles((theme)=>({ 
  row:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  basicConfigBlock:{
    fontSize:'14px'
  },
  basicConfigBlockH1:{
    padding:'40px 0 0 10px',
    fontWeight:'700',
    fontSize:'22px',

  },
  basicConfigLi:{ 
    display:'flex',    
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  basicConfigSpan:{
    width:'250px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      paddingBottom:'10px',
    },
  },
  oneSpanDiv:{
    display:'flex'
  },
  oneSpan:{
    display:'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start'
  },
  oneSpanTextFieldShort:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'50%'
    },
  },
  textFieldShort:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  UlLi:{
    paddingBottom:'10px'
  },
  UlLiP:{
    display:'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
  },
  basicConfigLeftDiv:{
    width:'250px',
    textAlign:'left',
  },
  formControl:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  formControlSelect:{ 
    width:'100%',
  },
  twoFlexLi:{
    display:'flex',
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  basicConfigLiLeft:{
    width:'50%',
    display:'flex', 
    alignItems:'center', 

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
      paddingBottom:'10px'
    },
  },
  basicConfigLiRight:{
    width:'50%',
    display:'flex', 
    alignItems:'center', 

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
    },
  },
  checkboxLi:{
    position:'relative'
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px',
    paddingBottom:'20px'
  },
  btnButton:{
    margin:'0 40px'
  },
  basicConfigLiTextarea:{
    width:'440px',
    height:'100px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  }

}));
const Insta = () => {

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const theme = useTheme();
  const classes = useStylesInsta(theme);

  //인스타 설정
  const [instaId, setInstaId] = useState('');
  const [instaToken, setInstaToken] = useState();
  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);


  const getData = async() => {
    try{
      const res = await axios.get('/api/adm/configInstaView/')
      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      const resData = res.data.result

      setInstaId(resData.cf_syndi_token)
      setInstaToken(resData.cf_syndi_except)

    }catch(e){
      console.log(e)
    }
  }
  useEffect(() => {
    getData()
  }, [])

  const editData = async() => {
    try {
      const res = await axios.post('/api/adm/configEditInsta/', {
        cf_syndi_token: instaId,
        cf_syndi_except: instaToken,
      })

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      setSuccSnack(true)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }


  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };


  return(
    <div className={classes.basicConfigBlock}>
      <div className={classes.row}>
        <h1 className={classes.basicConfigBlockH1}>인스타그램 설정</h1>
        <ul className={classes.basicConfigUl}>
          <li className={classes.basicConfigLi}>
            <div className={classes.basicConfigLeftDiv}>
              <span className={classes.basicConfigSpan} >인스타그램 아이디</span>
            </div>
            <ul>
              <li>
                <TextField 
                  value={instaId}
                  onChange={(e) => setInstaId(e.target.value)}
                  size='small' 
                  sx={{"& .MuiInputBase-root": {height: 25}}} 
                  className={classes.textFieldLong}  
                  hiddenlabel="true" 
                  variant="outlined" 
                />
              </li>
            </ul>
          </li>
          <li className={classes.twoFlexLi}>
            <div className={classes.basicConfigLiLeft}>
              <span className={classes.basicConfigSpan}>인스타그램 토큰</span>
              <ul>
                <li>
                  <textarea 
                    value={instaToken} 
                    onChange={(event) => setInstaToken(event.target.value)} 
                    className={classes.basicConfigLiTextarea} 
                  />
                </li>
              </ul>
            </div>
          </li>
          
        </ul>
        <div className={classes.btnDiv}>
          <div>
            <Button 
              variant="contained"
              onClick={() => {editData()}} 
            >
              확인
            </Button>
          </div>
        </div>
      </div>

      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
    </div>
  )
}




export default BasicConfig;

